export const HSZG = 'HSZG'
export const STUDENT = 'STUDENT'
export const EMPLOYEE = 'EMPLOYEE'
export const ALUMNI = 'ALUMNI'
export const COMPANY = 'COMPANY'

export default { EMPLOYEE, HSZG, STUDENT, ALUMNI, COMPANY }
